import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { Checkbox } from '~/eds/src/components/Checkbox/Checkbox';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { SearchInput } from '~/eds/src/components/SearchInput/SearchInput';
import { Nullable } from '~/types/Nullable';

type Props = {
  options?: string[];
  search?: string;
  selectAll: Nullable<boolean>;
  onSearch: (search: string) => void;
  onSelectAllToggle: (selectAll: Nullable<boolean>) => void;
};

export const OptionsManager = ({
  options = [],
  search = '',
  selectAll,
  onSearch,
  onSelectAllToggle,
}: Props) => {
  const intl = useIntl();
  const [localSearch, setSearch] = useState(search);
  return (
    <Layout justify="space-between" pb={4} px={4} align="center">
      <SearchInput
        autoFocus
        name="search"
        value={localSearch}
        onChange={(value) => {
          setSearch(value || '');
          onSearch(value || '');
        }}
        placeholder={intl.formatMessage({
          id: 'OptionsManager.searchPlaceholder',
          defaultMessage: 'Search',
          description: 'Placeholder text for search input',
        })}
      />
      <Layout>
        <Checkbox
          disabled={!options.length}
          name="selectAll"
          value={selectAll}
          onChange={onSelectAllToggle}
          option={{
            label: intl.formatMessage({
              id: 'OptionsManager.selectAll',
              defaultMessage: 'Select All',
              description: 'Checkbox label for selecting all options',
            }),
            value: selectAll,
          }}
        />
      </Layout>
    </Layout>
  );
};
